export default {
  confirmProduct: {},
  selectedCoupon: {},
  couponList: [],
  confirmCoupons: {
    usableList: [],
    disableList: []
  },
  confirmSelected: {
    store: {},
    city: {}
  },
  isOpenAppCashier: false,
  payPrice: 0, //应付价格:总价减优惠 单位分
  isSupportScore: false, //是否支持积分
  payScore: 0, //应付积分
  isLessScore: false //积分不足
}
